import { combineReducers } from "redux";

import { AnalyticsReducer } from "./analytics/AnalyticsReducer";
import { ConfigReducer } from "./config/ConfigReducer";
import { EntitiesReducer } from "./entities/EntitiesReducer";
import LayoutReducer from "./layout/LayoutReducer";
import { PagesReducer } from "./pages/PagesReducer";
import { RouteReducer } from "./route/RouteReducer";
import { UsageTrackReducer } from "./usage-track/UsageTrackReducer";
import { VisualizerReducer } from "./visualizer/VisualizerReducer";
import type { RootState } from "./RootState";

export const RootReducer = combineReducers<RootState>({
	analytics: AnalyticsReducer,
	config: ConfigReducer,
	layout: LayoutReducer,
	usageTrack: UsageTrackReducer,
	entities: EntitiesReducer,
	pages: PagesReducer,
	location: RouteReducer,
	visualizer: VisualizerReducer,
});
